document.addEventListener('alpine:init', function () {
    Alpine.data('homeFindYourMatch', function () {
        var glide;
        return {
            activeSlide: 0,
            init: function () {
                this.initialiseCarousel();
            },
            initialiseCarousel: function () {
                var _this = this;
                glide = new window.Glide(this.$refs.carousel, {
                    type: 'carousel',
                    gap: 112,
                    perView: 3,
                    breakpoints: {
                        1600: {
                            gap: 48,
                        },
                        1024: {
                            perView: 2,
                            gap: 32,
                        },
                        768: {
                            perView: 1,
                            gap: 24,
                        },
                    },
                });
                // Initial run. Must be defined before calling `glide.mount()`.
                glide.on('mount.after', function () {
                    _this.handleInertSlides();
                });
                glide.on('run.after', function () {
                    _this.activeSlide = glide.index;
                    _this.handleInertSlides();
                });
                glide.mount();
            },
            handleInertSlides: function () {
                var slides = Array.from(this.$refs.carousel.querySelectorAll('.glide__slide'));
                // Set all slides to be inert.
                slides.forEach(function (slide, i) {
                    slide.setAttribute('inert', '');
                });
                // Remove inert attribute for the visible slides
                if (!this.$store.app.md) {
                    slides.find(function (slide) { return slide.classList.contains('glide__slide--active'); }).removeAttribute('inert');
                }
                else {
                    var slideIndices = [];
                    var activeSlideIndex = slides.findIndex(function (slide) {
                        return slide.classList.contains('glide__slide--active');
                    });
                    if (this.$store.app.md && !this.$store.app.lg) {
                        // Between 768 and 1024, we only have 2 slides being shown.
                        slideIndices = [activeSlideIndex, activeSlideIndex + 1];
                    }
                    else {
                        // Larger than 1024, we only have 3 slides being shown.
                        slideIndices = [activeSlideIndex, activeSlideIndex + 1, activeSlideIndex + 2];
                    }
                    slideIndices.forEach(function (i) {
                        slides[i].removeAttribute('inert');
                    });
                }
            },
        };
    });
});
